/**
 * Erkennt, ob der Browser noch eine alte Programmversion ausfuehrt.
 *
 * Die Seite ist eine Single-Page-App: einmal geladen, laeuft im Tab genau das
 * JavaScript weiter, das beim Oeffnen aktuell war — ein Deploy erreicht diesen
 * Tab erst beim naechsten Neuladen. Wer den Admin-Bereich ueber Nacht offen
 * laesst, erfasst also mit der Programmversion von gestern. Beim
 * Statistik-Import faellt das besonders teuer aus: ein alter Namensabgleich
 * laesst Spieler aus dem Screenshot stillschweigend weg.
 *
 * Geprueft wird gegen das asset-manifest.json des Builds (vom React-Build
 * erzeugt, liegt neben der index.html). Steht dort ein anderes main.js als das,
 * was dieser Tab geladen hat, ist der Tab veraltet.
 */

/** Pfad des main.js, das dieser Tab tatsaechlich geladen hat. */
const loadedBundlePath = () => {
  if (typeof document === 'undefined') return null;
  const script = document.querySelector('script[src*="/static/js/main."]');
  if (!script) return null;
  try {
    return new URL(script.src, window.location.origin).pathname;
  } catch (error) {
    return null;
  }
};

/**
 * @returns {Promise<boolean>} true, wenn der Server inzwischen einen neueren
 *   Build ausliefert. Im Zweifel (Entwicklungsmodus, Netzfehler, unbekanntes
 *   Manifest) false — lieber nicht warnen als faelschlich blockieren.
 */
export const isStaleBuild = async () => {
  const loaded = loadedBundlePath();
  if (!loaded) return false;

  try {
    const response = await fetch('/asset-manifest.json', { cache: 'no-store' });
    if (!response.ok) return false;

    const manifest = await response.json();
    const current = manifest?.files?.['main.js'];
    if (!current) return false;

    return current !== loaded;
  } catch (error) {
    return false;
  }
};

const buildVersion = { isStaleBuild };

export default buildVersion;
